import { render } from "./ClickBankActions.vue?vue&type=template&id=55c55008"
import script from "./ClickBankActions.vue?vue&type=script&lang=js"
export * from "./ClickBankActions.vue?vue&type=script&lang=js"
script.render = render

export default script